import { RegistrationMode } from '@ytl/common-model';

import { useTheme } from '@ytl/common-web';
import { MutableRefObject, useEffect, useLayoutEffect, useRef } from 'react';
import { RegisterB2bWebView } from '../modules/registerb2b/RegisterB2bWebView';
import { useQueryParams } from '../shared/utils/useQueryParams';

export enum RegistrationPhase {
  Form = 'form',
  Result = 'result',
  EmailOTP = 'emailOtp',
  RegistrationComplete = 'registrationComplete',
  RegistrationFailed = 'registrationFailed',
}

export const RegisterB2bPage = ({ isRawLayout }: { isRawLayout: boolean }) => {
  const query = useQueryParams();
  const registrationMode = (query.get('mode')?.toLowerCase() as RegistrationMode) || RegistrationMode.Default;
  const { isWebView } = useTheme();
  const prevIsWebViewRef: MutableRefObject<any> = useRef(null);

  useLayoutEffect(() => {
    document.documentElement.classList.add('register-page');
    if (isRawLayout) {
      document.documentElement.classList.add('register-page--raw');
    }
    return () => {
      document.documentElement.classList.remove('register-page');
      document.documentElement.classList.remove('register-page--raw');
    };
  }, [isRawLayout]);

  useEffect(() => {
    if (prevIsWebViewRef.current !== isWebView) {
      prevIsWebViewRef.current = isWebView;
    }
  }, [isWebView]);

  return (
    <>
      <RegisterB2bWebView registrationMode={registrationMode} />
    </>
  );
};
